import { throttle } from 'lodash-es';

interface ScrollUpOptions {
  scrollUpButton: HTMLElement | null
  visibilityReason?: {
    percentage?: number
  }
  paddingBottom?: number
}

function checkVisibility(visibilityReason: ScrollUpOptions['visibilityReason'] = { percentage: 10 }, paddingBottom = 0) {
  const scrollTop = window.scrollY;
  const scrollHeight = document.documentElement.scrollHeight;
  const clientHeight = window.innerHeight;
  const maximumScrollY = scrollHeight - clientHeight;

  const { percentage } = visibilityReason;

  // Hide button if we are near the bottom of the page
  if (scrollTop >= maximumScrollY - paddingBottom) {
    return false;
  }

  if (percentage !== undefined) {
    const scrolledPercentage = 100 * scrollTop / maximumScrollY;

    return scrolledPercentage >= percentage;
  }

  return false;
}

export function initScrollTop({ scrollUpButton, visibilityReason, paddingBottom }: ScrollUpOptions) {
  if (!scrollUpButton) {
    return;
  }

  window.addEventListener('scroll', throttle(() => {
    const showButton = checkVisibility(visibilityReason, paddingBottom);

    scrollUpButton.classList.toggle('show', showButton);
  }, 300));

  scrollUpButton.addEventListener('click', (event: PointerEvent) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}
